import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "employeeSelect"]

  connect() {
    console.log("HourlyRatesFilters controller connected")
    this.initializeSelects()
  }

  initializeSelects() {
    if (this.hasEmployeeSelectTarget) {
      $(this.employeeSelectTarget).select2({
        theme: 'tailwind',
        placeholder: this.placeholderValue || 'Sélectionner un enseignant',
        allowClear: true
      })

      // Déclencher la soumission du formulaire lors du changement
      $(this.employeeSelectTarget).on('change', this.submit.bind(this))
    }
  }

  submit() {
    this.formTarget.requestSubmit()
  }
}